let debounceTimer: number

export function debouncer (callback: Function) {
    window.clearTimeout(debounceTimer)
    debounceTimer = window.setTimeout(callback, 200)
}